<template>
    <div class="px-4 py-4">
        <div>
            <v-icon class="float-right" @click="onClose({...data, status:false})">mdi-close</v-icon>
        </div>
        <h5>Terms and Conditions</h5>
        <div class="terms-scroll">
        <ol>
            <li>
                All the Premium Papers available in this platform contains Questions in
                the English language only.
            </li>
            <li>
                You can answer any of the tests that you purchase at any date or time till
                st upcoming 31 May. Your access to the papers shall be disabled automatically
                past this date.
            </li>
            <li>
                The questions provided in this platform are taken from the official websites of
                the respective examination or from other reliable sources when official paper is
                not available. This platform is not liable for accuracy of the questions, answers
                in such cases as this platform only serves the purpose of simulating the exams
                held earlier.
            </li>
            <li>
                The Interface used to answer the examinations may not replicate the actual
                examination interface.
            </li>
            <li>
                The All India Rank predicted after your submission of a test is based on the
                extrapolation of the data of marks vs rank available for the respective exam and
                may or may not be accurate despite our best efforts.
            </li>
        </ol>
        </div>
        <div class="text-center">
            <v-btn centered color="primary" @click="onClose({...data, status:false})">OK</v-btn>
        </div>
    </div>
</template>
<script>
export default {
    props: ["onClose", "data", "status"]
};
</script>